// Module
var code = " <div class=\"\"> Demo </div> <div id=\"demoContainer1\"> hello1 </div> <hr> <div id=\"demoContainer2\"> hello2 </div> ";
// Exports
export default code;